import React from 'react';
import styled from 'styled-components';
import {useCurrentMailCampaignContractQuery} from 'api';
import useSearchParams from './useSearchParams';

const ProgressbarContainer: React.FC = () => {
  const {query} = useSearchParams();
  const {data: {currentMailCampaignContract = {}} = {}} =
    useCurrentMailCampaignContractQuery({
      fetchPolicy: 'cache-and-network',
    });

  const mailCampaignSendsUsage =
    query.target === 'prospects'
      ? currentMailCampaignContract?.mailCampaignSendsUsageProspect || 0
      : currentMailCampaignContract?.mailCampaignSendsUsage || 0;
  
  const mailCampaignSendsLimit =
    query.target === 'prospects'
      ? currentMailCampaignContract?.mailCampaignSendsLimitProspect || 0
      : currentMailCampaignContract?.mailCampaignSendsLimit || 0;

  const statusLabel = query.target === 'prospects' ? '送信件数_リード' : '送信件数_営業リスト';
  const progressPercentage = mailCampaignSendsLimit > 0 ? (mailCampaignSendsUsage / mailCampaignSendsLimit) * 100 : 0;

  return (
    <Container>
      <Meta>
        <Status>{statusLabel}</Status>
        <ProgressNumber>
          {`${mailCampaignSendsUsage?.toLocaleString()} / ${mailCampaignSendsLimit ? mailCampaignSendsLimit.toLocaleString() : '-'}`}
        </ProgressNumber>
      </Meta>
      <ProgressbarWrapper>
        <Progressbar width={progressPercentage} />
      </ProgressbarWrapper>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 160px;
  margin-right: 18px;
  * {
    margin: auto 0;
  }
`;

const Meta = styled.div`
  display: flex;
  align-items: end;
`;

const Status = styled.div`
  margin-left: 2px;
  width: 120px;
  font-size: 12px;
  color: var(--text-color-1);
  flex-shrink: 0;
`;

const ProgressNumber = styled.span`
  margin-left: auto;
  font-size: 12px;
  color: var(--text-color-1);
  white-space: nowrap;
`;

const ProgressbarWrapper = styled.span`
  margin-top: 5px;
  position: relative;
  height: 6px;
  background: var(--border-color);
  border-radius: 10px;
`;

const Progressbar = styled.span<{
  width: number;
}>`
  position: absolute;
  width: ${({width}) => `${width}%`};
  height: 6px;
  background: #8966ef;
  border-radius: 10px;
`;

export default ProgressbarContainer;